
import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { PatentImages, PatentImageService } from '../patent-image-service';
import { PatentImageApi } from '@telecom/shared/infrastructure/api-functions/patent-image-api';

@injectable()
export class PatentImageServiceImpl implements PatentImageService {
    constructor(
        @inject(PatentImageApi)
        private readonly _patentImageApi: PatentImageApi,
    ) {}
    getPatentOfficeImage(payload: {patentId: string}): Promise<PatentImages> {
        return this._patentImageApi.getPatentOfficeImage(payload);
    }
}
